/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */

window.cb_newview = function cb_newview(result) {
  window.do_openview(result);
};

window.cb_openview = function cb_openview(result) {
  window.do_openview(result);
};

window.do_openview = function do_openview(result) {
  const pannel_id = 'view'; // ignore result['pannel_id']
  const pannel = window.getViewPannel(pannel_id);

  if (!pannel) {
    window.finishAjaxRequest(pannel_id, result);
    return;
  }

  window.clearWorking(pannel);

  pannel.current_type = 'view';
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'ajax_view' does not exist on type 'Parti... Remove this comment to see the full error message
  pannel.view = result.ajax_view;

  if (
    window.breadcrumbs &&
    window.breadcrumbs.length >= 1 &&
    window.breadcrumbs[window.breadcrumbs.length - 1].title === undefined
  ) {
    window.popParent();
  }

  // Check to see if we need to update the previous parent (as on save)
  // The check for undefined title catches new records
  let length = 0;
  if (window.breadcrumbs) {
    length = window.breadcrumbs.length;
  }

  if (
    length > 0 &&
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    (window.breadcrumbs[length - 1].name === pannel.view.name ||
      (window.breadcrumbs[length - 1].title &&
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        window.breadcrumbs[length - 1].title.indexOf('New') !== 0 &&
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'record_id' does not exist on type 'Bread... Remove this comment to see the full error message
        window.breadcrumbs[length - 1].record_id === null))
  ) {
    window.popParent();
    window.pushParent(pannel);
  } else {
    window.pushParent(pannel);
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'view_tabs_loaded' does not exist on type... Remove this comment to see the full error message
  pannel.view_tabs_loaded = [];
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'view_tabs_loaded' does not exist on type... Remove this comment to see the full error message
  pannel.view_tabs_loaded[pannel.view.tab] = true;

  // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
  window.merchantos.page.show('view', { html: result.html });

  window.setViewTitle(pannel);
  window.autoLoadListings(pannel, pannel.id);

  window.initCustomFields(pannel.view);

  window.subscribeViewKeys(pannel.id);

  pannel.has_changes = false;

  window.setAutoFocus(pannel);

  window.clearFieldChanges(pannel);

  window.refreshPageHeader(pannel);

  $(pannel).trigger('viewready');

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  if (pannel.view.go_back) {
    /*
     * We need to get rid of the state up to go_back-1 but we don't actually
     * want to route()
     *
     * So we have a hack:
     *
     * window._ignore_popstate will tell the onpopstate() call
     * (see router.js) to exit before calling route(). because the current
     * URL (window.location) will have already changed we have to do a
     * replaceState within onpopstate so we need the window.location.href
     * and pannel.view (.title and viewContext) to set replaceState
     * correctly.
     *
     * Do you feel like you are in Inception?
     */
    window._ignore_popstate = [window.location.href, pannel.view];
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    window.history.go(pannel.view.go_back - 1);
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    pannel.view.go_back = false;
  }

  window.finishAjaxRequest(pannel, result);
};

window.cb_saverecord = function cb_saverecord(result) {
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'ajax_view' does not exist on type 'Parti... Remove this comment to see the full error message
  if (result.ajax_view) {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
    const pannel = window.getViewPannel(result.pannel_id);

    if (!pannel) {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
      window.finishAjaxRequest(result.pannel_id, result);
      return;
    }

    pannel.current_type = 'view';
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'ajax_view' does not exist on type 'Parti... Remove this comment to see the full error message
    pannel.view = result.ajax_view;
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'clean' does not exist on type 'Partial<{... Remove this comment to see the full error message
  if (result.clean) {
    window.clearFieldChanges(result.pannel_id);
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'return_to_parent' does not exist on type... Remove this comment to see the full error message
  if (result.return_to_parent) {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
    window.pushQueueRequest(result.pannel_id, `returnToParent('${result.pannel_id}');`);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'refresh' does not exist on type 'Partial... Remove this comment to see the full error message
  } else if (result.refresh) {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
    window.pushQueueRequest(result.pannel_id, `openView('${result.pannel_id}');`);
  }

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
  window.finishAjaxRequest(result.pannel_id, result);
};

window.cb_doviewfunction = function cb_doviewfunction(result) {
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'ajax_view' does not exist on type 'Parti... Remove this comment to see the full error message
  if (result.ajax_view) {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
    const pannel = window.getViewPannel(result.pannel_id);

    if (!pannel) {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
      window.finishAjaxRequest(result.pannel_id, result);
      return;
    }

    pannel.current_type = 'view';
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'ajax_view' does not exist on type 'Parti... Remove this comment to see the full error message
    pannel.view = result.ajax_view;
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'clean' does not exist on type 'Partial<{... Remove this comment to see the full error message
  if (result.clean) {
    window.clearFieldChanges(result.pannel_id);
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'return_to_parent' does not exist on type... Remove this comment to see the full error message
  if (result.return_to_parent) {
    if (!result.requests) {
      result.requests = [];
    }
    result.requests.push(`returnToParentX('${result.pannel_id}', 2);`);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'refresh' does not exist on type 'Partial... Remove this comment to see the full error message
  } else if (result.refresh) {
    if (!result.requests) {
      result.requests = [];
    }
    result.requests.push(`openView('${result.pannel_id}');`);
  }

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
  window.finishAjaxRequest(result.pannel_id, result, () => {
    if (
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'ajax_view' does not exist on type 'Parti... Remove this comment to see the full error message
      result.ajax_view &&
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'ajax_view' does not exist on type 'Parti... Remove this comment to see the full error message
      result.ajax_view.name === 'admin.views.options' && // CLD-6350
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'ajax_view' does not exist on type 'Parti... Remove this comment to see the full error message
      result.ajax_view.tab !== 'currencies' // CLD-35863
    ) {
      // @ts-expect-error The boolean here is a firefox non-standard api  https://developer.mozilla.org/en-US/docs/Web/API/Location/reload#location.reload_has_no_parameter
      location.reload(true);
    }
  });
};

window.subscribeViewKeys = function subscribeViewKeys(pannel_id) {
  window.merchantos.keyboard.subscribe('Alt+pageup', () => window.recordBack(pannel_id));
  window.merchantos.keyboard.subscribe('Alt+pagedown', () => window.recordForward(pannel_id));
  window.merchantos.keyboard.subscribe('Alt+home', () => window.gotoFirstRecord(pannel_id));
  window.merchantos.keyboard.subscribe('Alt+end', () => window.gotoLastRecord(pannel_id));
  window.merchantos.keyboard.subscribe('Alt+s', () => {
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    document.activeElement.blur();
    window.doViewFunction(pannel_id, 'save');
  });
  window.merchantos.keyboard.subscribe('Alt+c', () => window.returnToParent(pannel_id));
  window.merchantos.keyboard.subscribe('Alt+r', () => window.doViewFunction(pannel_id, 'refresh'));
  window.merchantos.keyboard.subscribe('Alt+d', () => {
    if (confirm('Are you sure you want to delete this record?'))
      window.doViewFunction(pannel_id, 'delete');
  });
  window.merchantos.keyboard.subscribe('Alt+a', () => {
    if (confirm('Are you sure you want to archive this record?'))
      window.doViewFunction(pannel_id, 'archive');
  });
};

/**
 * Opens a new non-listing view.
 * @param {String} pannel_id
 * @param {String} name
 * @param {String} record_id
 * @param {String} tab
 * @param {String} context
 * @param {Boolean} reset_settings - Used to refresh some user search settings
 * @return {$.Deferred}
 */
window.newView = function newView(pannel_id, name, record_id, tab, context, reset_settings) {
  $('body,html').scrollTop(0);
  // TODO: Confirm this is in window scope or can be deleted
  window.parent_pannel_id = pannel_id as string;
  pannel_id = 'view'; // ignore passed in pannel_id, we changed things to be hard set to pannel_id=view for views.
  pannel_id = window.getRealPannelID(pannel_id);
  let pannel = window.xGetElementById(pannel_id);
  const promise = $.Deferred();

  if (!pannel) return promise.resolve().promise();

  if (window.isWorking(pannel)) {
    // Try again if we're working
    setTimeout(() => window.newView(pannel_id, name, record_id, tab, context, reset_settings), 50);
    return promise.resolve().promise();
  }

  if (reset_settings) {
    window.RefreshListing(pannel_id, true);
  }

  window.saveOnChanges(pannel).done(() => {
    pannel = window.xGetElementById(pannel_id);

    pannel = window.getViewPannel(pannel_id);
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    pannel.view.go_back = false;
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    pannel.view.count = 0;
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    pannel.view.rec_num = 0;
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    if (tab) pannel.view.tab = tab;

    if (!pannel) return;

    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    pannel.view.name = name;
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    if (record_id) pannel.view.record_id = record_id;
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    else pannel.view.record_id = 0;

    if (context) {
      pannel.view = context;
    }
    window.setWorking(pannel);

    const listingPannel = window.getListingPannel('listing');
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
    if (listingPannel.listing && listingPannel.listing.title) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'boolean... Remove this comment to see the full error message
      pannel.stored_listing = listingPannel.listing;
    }

    const content_map = {} as ContentMap;
    content_map.form_name = 'view.open';
    content_map.ajax_view = window.toJsonString(pannel.view);
    content_map.pannel_id = pannel.id;
    window.doServerCall(content_map, window.cb_newview).always(() => promise.resolve());
  });

  return promise;
};

window.saveDynamicData = function saveDynamicData(pannel) {
  const saveDeferred = $.Deferred();
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  const id = pannel.view.record_id;
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'Partial<{ name: string; title: s... Remove this comment to see the full error message
  const recordType = window.getRecordType(pannel.view);

  const $prices = window.merchantos.prices.getPricesContainer($(pannel));
  const $customFields = $(pannel).find('fieldset.customfields');

  let priceData = {};

  let customFieldData = {};
  if ($prices && $prices.length > 0) {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | number | undefined' is ... Remove this comment to see the full error message
    priceData = window.merchantos.prices.constructUpdateData(id, $prices);
  }
  if ($customFields && $customFields.length > 0) {
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'void | CustomFieldRecord' is not assignable ... Remove this comment to see the full error message
    customFieldData = window.merchantos.custom_fields.constructUpdateData(
      $customFields,
      pannel.view
    );
  }

  let prop;
  if (recordType === 'Item' && window._pageNeedsDynamicSave(pannel)) {
    const item = {
      itemID: id,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'CustomFieldValues' does not exist on typ... Remove this comment to see the full error message
      CustomFieldValues: customFieldData.CustomFieldValues,
    };
    // eslint-disable-next-line
    for (prop in priceData) {
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      item[prop] = priceData[prop];
    }

    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | number | undefined' is ... Remove this comment to see the full error message
    window.merchantos.itemCaching.load(id).always(() =>
      window.merchantos.itemCaching
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | number | undefined' is ... Remove this comment to see the full error message
        .save(id, item)
        .done(() => saveDeferred.resolve())
        .fail(() => {
          const msg = `window.merchantos.itemCaching.save failed:  id=${id} item=${JSON.stringify(
            item
          )}`;
          window.merchantos.error(msg);
          saveDeferred.reject();
        })
    );
  } else {
    const data = {};
    // eslint-disable-next-line
    for (prop in priceData) {
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      data[prop] = priceData[prop];
    }
    // eslint-disable-next-line
    for (prop in customFieldData) {
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      data[prop] = customFieldData[prop];
    }
    window
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | number | undefined' is ... Remove this comment to see the full error message
      .saveViewDataToAPI(recordType, id, data)
      .done(() => saveDeferred.resolve())
      .fail(() => {
        const msg = `saveViewDataToAPI failed: recordType=${recordType} id=${id} data=${JSON.stringify(
          data
        )}`;
        window.merchantos.error(msg);
        saveDeferred.reject();
      });
  }

  return saveDeferred.promise();
};

window._pageNeedsDynamicSave = function _pageNeedsDynamicSave(pannel) {
  let required = false;
  const itemCachingViews = [
    'item.views.item',
    'item.views.quick_add',
    'customer.views.customer',
    'purchase.views.purchase',
  ];
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  if (itemCachingViews.indexOf(pannel.view.name) != -1) {
    required = true;
  }
  return required;
};

window.saveViewDataToAPI = function saveViewDataToAPI(recordType, id, data) {
  let url = `/API/Account/${window.merchantos.session.getSystemCustomerID()}`;
  url += `/${recordType}/${id}.json`;
  let deferred = $.Deferred();
  if (data && !$.isEmptyObject(data)) {
    deferred = window.lsCloud.startServerJob({
      url,
      obj: data,
    });
  } else {
    deferred.resolve();
  }

  return deferred.promise();
};

window.getRecordType = function getRecordType(view) {
  const name = view.name.split('.')[0];
  switch (name) {
    case 'purchase':
      return 'Order';
    case 'item_group':
      return 'ItemMatrix';
    default:
      return name.charAt(0).toUpperCase() + name.slice(1);
  }
};

window.openView = function openView(pannel_id) {
  pannel_id = 'view'; // ignore passed in pannel_id, we changed things to be hard set to pannel_id=view for views.
  const pannel = window.getViewPannel(pannel_id);

  if (!pannel) return;

  if (window.isWorking(pannel)) return;

  window
    .saveDynamicData(pannel)
    .done(() =>
      window.saveOnChanges(pannel).done(() => {
        window.setWorking(pannel);

        const content_map = {} as ContentMap;
        content_map.form_name = 'view.open';
        content_map.ajax_view = window.toJsonString(pannel.view);
        content_map.pannel_id = pannel.id;
        window.doServerCall(content_map, window.cb_openview);
      })
    )
    .fail(jqXHR => {
      window.merchantos.error(`Error opening view: ${window.toJsonString(pannel.view)}`);
      if (jqXHR && jqXHR.status === 400) {
        const responseXML = $.parseXML(jqXHR.responseText);
        const customFieldID = $(responseXML)
          .find('customFieldID')
          .text();
        // @ts-expect-error ts-migrate(2552) FIXME: Cannot find name 'customFields'. Did you mean 'cus... Remove this comment to see the full error message
        const errorField = $(customFields).find(`input[name$="-${customFieldID}"]`);
        errorField.addClass('error');
        errorField.siblings('.field-error').removeClass('hidden');
      }
    });
};

// @ts-expect-error ts-migrate(2322) FIXME: Type '(pannel: PanelId) => false | PanelId' is not... Remove this comment to see the full error message
window.getViewPannel = function getViewPannel(pannel) {
  // @ts-expect-error ts-migrate(2322) FIXME: Type 'HTMLElement | undefined' is not assignable t... Remove this comment to see the full error message
  pannel = window.xGetElementById(pannel);

  if (!pannel) {
    return false;
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'current_type' does not exist on type 'Pa... Remove this comment to see the full error message
  if (!pannel.current_type) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'listing' does not exist on type 'PanelId... Remove this comment to see the full error message
    if (pannel.listing) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'current_type' does not exist on type 'Pa... Remove this comment to see the full error message
      pannel.current_type = 'listing';
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'view' does not exist on type 'PanelId'.
    } else if (pannel.view) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'current_type' does not exist on type 'Pa... Remove this comment to see the full error message
      pannel.current_type = 'view';
    } else {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'current_type' does not exist on type 'Pa... Remove this comment to see the full error message
      pannel.current_type = false;
    }
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'view' does not exist on type 'PanelId'.
  if (pannel.view) return pannel;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'view' does not exist on type 'PanelId'.
  pannel.view = {};
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'view' does not exist on type 'PanelId'.
  pannel.view.count = 0;
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'view' does not exist on type 'PanelId'.
  pannel.view.rec_num = 0;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'has_changes' does not exist on type 'Pan... Remove this comment to see the full error message
  pannel.has_changes = false;

  return pannel;
};

window.saveRecord = function saveRecord(pannel_id, closing) {
  const pannel = window.getViewPannel(pannel_id);
  const deferred = $.Deferred();

  if (!pannel) return deferred.resolve();

  // no changes
  if (!pannel.has_changes) return deferred.resolve();

  // @ts-expect-error ts-migrate(2448) FIXME: Block-scoped variable 'promise' used before its de... Remove this comment to see the full error message
  if (window.isWorking(pannel)) return promise.resolve();

  window.fillViewKeyValues(pannel);

  const content_map = {} as ContentMap;
  content_map.form_name = 'view.doevent';
  content_map.ajax_view = window.toJsonString(pannel.view);
  content_map.event = 'save';
  content_map.key_values = window.toJsonString(pannel.key_values);
  content_map.pannel_id = pannel.id;
  if (closing) {
    content_map.is_closing = true;
  }

  const promise = window.doServerCall(content_map, window.cb_doviewfunction);

  promise
    .done(data => {
      if (data && data.failed_msg) {
        deferred.reject(data.failed_msg);
      } else {
        window.deactivateViewOnChangeButtons(pannel);
        pannel.has_changes = false;
        deferred.resolve();
      }
    })
    .fail(() => deferred.reject('An error has occurred communicating with the server'));

  return deferred;
};

window.doViewEvent = function doViewEvent(pannel_id, event, event_data) {
  const pannel = window.getViewPannel(pannel_id);

  if (!pannel) return;

  if (window.isWorking(pannel)) return;

  window.fillViewKeyValues(pannel);

  const content_map = {} as ContentMap;
  content_map.form_name = 'view.doevent';
  content_map.ajax_view = window.toJsonString(pannel.view);
  content_map.event = event;
  content_map.key_values = window.toJsonString(pannel.key_values);
  if (event_data) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'event_data' does not exist on type 'Cont... Remove this comment to see the full error message
    content_map.event_data = window.toJsonString(event_data);
  }
  content_map.pannel_id = pannel.id;
  window.doServerCall(content_map, window.cb_doviewfunction);

  window.deactivateViewOnChangeButtons(pannel);
  pannel.has_changes = false;
};

window.gotoRecordNumber = function gotoRecordNumber(pannel_id, rec_num) {
  const pannel = window.getViewPannel(pannel_id);

  if (!pannel) return;
  if (isNaN(rec_num)) return;

  if (rec_num < 1) rec_num = 1;
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  if (rec_num > pannel.view.count) rec_num = pannel.view.count;

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  if (rec_num === pannel.view.rec_num) return;

  window.openListingRecordNum(pannel, rec_num);
};

window.recordBack = function recordBack(pannel_id) {
  const pannel = window.getViewPannel(pannel_id);

  if (!pannel) return;

  window.popParent();

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  window.gotoRecordNumber(pannel, pannel.view.rec_num - 1);
};

window.recordForward = function recordForward(pannel_id) {
  const pannel = window.getViewPannel(pannel_id);

  if (!pannel) return;

  window.popParent();

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  window.gotoRecordNumber(pannel, pannel.view.rec_num + 1);
};

window.gotoFirstRecord = function gotoFirstRecord(pannel_id) {
  window.gotoRecordNumber(pannel_id, 1);
};

window.gotoLastRecord = function gotoLastRecord(pannel_id) {
  const pannel = window.getViewPannel(pannel_id);

  if (!pannel) return;

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  window.gotoRecordNumber(pannel, pannel.view.count);
};

window.gotoArbitraryRecord = function gotoArbitraryRecord(pannel_id) {
  // eslint-disable-next-line no-alert
  const num = prompt('What record number would you like to turn to?');

  if (num) window.gotoRecordNumber(pannel_id, parseInt(num, 10));
};

$(document).on('click', '#view .tab-labels a', function onViewTabLabelClick(event) {
  event.preventDefault();

  // Extract pannel name from like (remove hash )
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  const tab_name = $(this)
    .attr('href')
    .replace('#', '');
  const pannel = $('#view')[0];

  window.merchantos.views.tabToggle(pannel, tab_name);
});

window.merchantos.views = {
  tabToggle(pannel, tab_name) {
    const tab = $(`#view .tabs .view_tab_${tab_name}`);

    // remove current from all tab selectors that are not this
    $('#view .tab-labels li.current').removeClass('current');

    // add current to this tab selector
    $(`#view .tab-labels li.${tab_name}`).addClass('current');

    // Set the crumb to have the correct tab name
    const parents = window.breadcrumbs;
    if (parents) {
      const lastParent = parents[parents.length - 1];
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      if (lastParent && lastParent.name === pannel.view.name) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'tab' does not exist on type 'Breadcrumb'... Remove this comment to see the full error message
        window.breadcrumbs[parents.length - 1].tab = tab_name;
      }
    }

    if (tab.hasClass('loaded')) {
      this.showTabContent(tab, tab_name, true);
    } else {
      tab
        .removeClass('not_loaded')
        .removeClass('loaded')
        .addClass('loading');
      // Load the pannel if we already have it
      this.getTab(pannel, tab_name);
    }
  },

  showTabContent(tab, tab_name, doRefreshPageHeader) {
    const pannel = window.getViewPannel('view');
    if (tab_name) {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      pannel.view.tab = tab_name;
    }
    // hide any open tabs that aren't this tab
    tab.siblings(':visible').addClass('inactive');

    // Show de tab
    tab.removeClass('inactive');

    if (doRefreshPageHeader) {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'HTMLElement | undefined' is not ... Remove this comment to see the full error message
      window.refreshPageHeader(pannel);
    }
  },

  getTab(pannel, tab_name) {
    const content_map = {} as ContentMap;
    content_map.form_name = 'view.gettab';
    content_map.ajax_view = window.toJsonString(pannel.view);
    content_map.tab = tab_name;
    content_map.pannel_id = pannel.id;

    window.doServerCall(content_map, window.merchantos.views.getTabCallback);
  },

  getTabCallback(result) {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
    const pannel = window.getViewPannel(result.pannel_id);
    if (!pannel) {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
      window.finishAjaxRequest(result.pannel_id, result);
      return;
    }

    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    pannel.view.tab = result.tab;

    const tab = $(`#view .tabs .view_tab_${result.tab}`);
    const tab_content = tab.find('.content');

    // Load the HTML into the content area
    tab_content.htmlReplace(result.html);

    // Do not display the tab if when the request gets back it's not the selected one
    if ($(`#view .tab-labels li.${result.tab}`).hasClass('current')) {
      window.merchantos.views.showTabContent(tab);
      window.refreshPageHeader(pannel);
    }

    window.autoLoadListings(pannel, pannel.id);

    window.initCustomFields(pannel.view);

    tab.removeClass('not_loaded loading').addClass('loaded');

    window.setAutoFocus(tab_content);

    $(pannel).trigger('viewready');

    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
    window.finishAjaxRequest(result.pannel_id, result);
  },
};

window.activateViewOnChangeButtons = function activateViewOnChangeButtons(pannel_id) {
  const pannel = window.getViewPannel(pannel_id);

  if (!pannel) return;

  $(pannel)
    .find('.on_dirty')
    .each(function onAddDirty() {
      $(this).addClass('dirty');
    });
};

window.deactivateViewOnChangeButtons = function deactivateViewOnChangeButtons(pannel_id) {
  const pannel = window.getViewPannel(pannel_id);

  if (!pannel) return;

  $(pannel)
    .find('.on_dirty')
    .each(function onRemoveDirty() {
      $(this).removeClass('dirty');
    });
};

window.doViewFunction = function doViewFunction(pannel_id, fnc) {
  const pannel = window.getViewPannel(pannel_id);

  if (!pannel) {
    return false;
  }

  if (window.isWorking(pannel)) {
    return false;
  }

  window.fillViewKeyValues(pannel);

  const content_map = {} as ContentMap;
  content_map.form_name = 'view.dofunction';
  content_map.ajax_view = window.toJsonString(pannel.view);
  content_map.fnc = fnc;
  content_map.key_values = window.toJsonString(pannel.key_values);
  content_map.pannel_id = pannel.id;
  window.doServerCall(content_map, window.cb_doviewfunction);

  return true;
};

window.checkPannelForChanges = function checkPannelForChanges(pannel_id) {
  const pannel = window.getViewPannel(pannel_id);

  // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
  if ($(pannel).find('.has_changed').length === 0) {
    window.deactivateViewOnChangeButtons(pannel_id);
  }
};

window.viewFieldSaveInitialValue = function viewFieldSaveInitialValue(el) {
  const $el = $(el);
  if ($el.data('value-onload') === undefined && $el.prop('value') !== undefined) {
    $el.data('value-onload', $el.prop('value'));
  }
};

window.viewFieldHasChanged = function viewFieldHasChanged(el) {
  const $el = $(el);
  switch (el.tagName.toLowerCase()) {
    case 'select':
      return $el.data('value-onload') !== $el.prop('value');
    case 'input':
      if (el.type.toLowerCase() === 'checkbox') {
        if (
          (!$el.prop('checked') && $el.attr('checked') === 'checked') ||
          ($el.prop('checked') && !$el.attr('checked'))
        ) {
          return true;
        }
        return false;
      }
      return $el.attr('value') !== $el.prop('value');
    case 'textarea':
      return $el.data('value-onload') !== $el.prop('value');
    default:
      // If we don't know how to evaluate field assume it changed to encourage user to save.
      return true;
  }
};

window.viewFieldChanged = function viewFieldChanged(pannel_id, el) {
  if (!pannel_id) {
    return;
  }

  if (!window.isObjectValid(window.do_saves)) {
    window.do_saves = {};
  }

  const pannel = window.getViewPannel(pannel_id);

  if (!pannel) {
    return;
  }

  if (el) {
    const $el = $(el);
    let has_changed = false;

    has_changed = window.viewFieldHasChanged(el as HTMLInputElement);

    if (has_changed) {
      $el.addClass('has_changed');

      // Verify that user didn't revert changes later reversing the need to save
      $el.on('keyup change blur', () => {
        if (!window.viewFieldHasChanged(el as HTMLInputElement)) {
          $el.removeClass('has_changed');
          window.checkPannelForChanges(pannel);
        }
      });
    } else {
      // No changes actually happened
      return;
    }
  }

  pannel.has_changes = true;
  window.activateViewOnChangeButtons(pannel);

  window.do_saves[pannel.id] = pannel.id;
};
window.clearFieldChanges = function clearFieldChanges(pannel_id) {
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'boolean | PanelId | undefined' i... Remove this comment to see the full error message
  let pannel = window.xGetElementById(pannel_id);
  if (pannel) {
    if (window.isObjectValid(window.do_saves)) {
      if (window.do_saves[pannel.id]) {
        delete window.do_saves[pannel.id];
      }
    } else {
      window.do_saves = {};
    }
  } else {
    window.do_saves = {};
  }

  if (!pannel_id) return;

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'true | PanelId' is not assignabl... Remove this comment to see the full error message
  pannel = window.getViewPannel(pannel_id);

  if (!pannel) return;

  pannel.has_changes = false;
  window.deactivateViewOnChangeButtons(pannel);
};

/**
 * Make a server call to save changes to a record if there are change fields
 * when the user attempts to navigate away
 *
 * @param pannel_id {string} The pannel_id, 'view' or 'listing'
 * @returns {array} [The promise object || the promise object resolved, boolean
 * 					indicating whether or not changes needed to be saved]
 */
window.saveOnChanges = function saveOnChanges(pannel_id) {
  // create and return a deferred object to ensure that processes after this
  // aren't executed out of order
  const deferred = $.Deferred();
  const message = 'This page contains unsaved changes. Save changes?';

  if (!pannel_id && window.do_saves) {
    if (window.do_saves.view) {
      pannel_id = $('#view')[0];
    } else {
      pannel_id = $('#listing')[0];
    }
  }

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
  const pannel = window.xGetElementById(pannel_id);

  if (window.isObjectValid(window.do_saves)) {
    if (pannel && !window.do_saves[pannel.id]) return deferred.resolve();
    // eslint-disable-next-line no-restricted-syntax
    for (const prop in window.do_saves) {
      // eslint-disable-next-line no-continue
      if (pannel && prop !== pannel.id) continue;
      if (confirm(message)) {
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
        const saveDeferred = window.saveRecord(pannel_id, true);
        window.clearFieldChanges(pannel_id);
        saveDeferred.done(deferred.resolve);
        return deferred.promise();
      }
      window.clearFieldChanges(pannel_id);
      return deferred.resolve();
    }
  }

  return deferred.resolve();
};

window.autoLoadViews = function autoLoadViews(p_pannel_id, parent_id) {
  const p_pannel = window.xGetElementById(p_pannel_id);
  if (!p_pannel) return;

  const autoviews = window.custGetElementsByClassName('auto_load_view', p_pannel);
  if (autoviews.length <= 0) return;

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < autoviews.length; i++) {
    const name = autoviews[i].name;
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'HTMLElement' is not assignable t... Remove this comment to see the full error message
    const id = window.getFormFieldValue(autoviews[i]);

    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | { [key: string]: string... Remove this comment to see the full error message
    const pannel = window.getViewPannel(id);
    // eslint-disable-next-line no-continue
    if (!pannel) continue;

    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    pannel.view.name = name;

    if (parent_id) pannel.parent_id = parent_id;

    const setups = window.custGetElementsByClassName(`${id}_setup`, pannel);
    if (setups.length <= 0) {
      window.pushQueueRequest(p_pannel, `openView('${id}');`);
      // eslint-disable-next-line no-continue
      continue;
    }

    // eslint-disable-next-line no-plusplus
    for (let p = 0; p < setups.length; p++) {
      const prop = setups[p].name;
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'HTMLElement' is not assignable t... Remove this comment to see the full error message
      const value = window.getFormFieldValue(setups[p]);

      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      pannel.view[prop] = value;
    }

    window.pushQueueRequest(p_pannel, `openView('${id}');`);
  }
};

window.fillViewKeyValues = function fillViewKeyValues(pannel_id) {
  const pannel = window.getViewPannel(pannel_id);
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  const key_values = window.getFormValues(`${pannel.id}_view`);
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  pannel.key_values = key_values;
};

window.setViewTitle = function setViewTitle(pannel_id) {
  const pannel = window.getViewPannel(pannel_id);

  if (!pannel) return;

  if (!pannel.view) return;

  const span = window.xGetElementById(`${pannel.id}_view_title`);
  // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
  if (span) span.innerHTML = pannel.view.title;
};

/**
 * A function to disable and "gray out" the content of a tab.  A disabled tab
 * must include an overlay div matching the overlayId provided to this function.
 * The height of overlay div is determined by the height of the tab's content
 * minus the first row which is the disable message displayed to the user.
 *
 * @param overlayId {String} - id of the overlay div element.
 */
window.disableTabContent = function disableTabContent(overlayId) {
  // Need to wait until the content is displayed before we can calculate
  // the height.
  function disableContentWithOverlay() {
    const overlay = $(`#${overlayId}`);
    const $tbody = overlay.closest('tbody');
    const $firstRow = $tbody.children('tr').first();

    setTimeout(function overlayHeightAdjustment() {
      if ($tbody.is(':visible')) {
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        const height = $tbody.height() - $firstRow.height();
        overlay.css('height', `${height}px`);
      } else {
        disableContentWithOverlay();
      }
    }, 200);
  }
  disableContentWithOverlay();
};

// Subscribe to tab disabling events.
(function subscribeToTabDisableNotificationsIIFE() {
  window.merchantos.asyncSubscribe.subscribeToFormCall('tab.disabled', window.disableTabContent);
})();
